module.exports = __webpack_public_path__ + "img/redhat.15cc3bc8.svg";